module.exports = __webpack_public_path__ + "img/parkinglist4.4cad0abb.png";